import React, {Component, useState} from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink, Card, Button, CardTitle, CardText, Row, Col } from 'reactstrap';
import classnames from 'classnames';


export default function BrandShow(props) {

	const [activeTab, setActiveTab] = useState('1');
 	const toggle = tab => {
    if(activeTab !== tab) setActiveTab(tab);
  }

	let {brand} = props;
	return (
		<div>
			<Nav tabs>
      <NavItem>
        <NavLink
          className={classnames({ active: activeTab === '1' })}
          onClick={() => { toggle('1'); }}
        >
          Brand
        </NavLink>
      </NavItem>
      <NavItem>
        <NavLink
          className={classnames({ active: activeTab === '2' })}
          onClick={() => { toggle('2'); }}
        >
          Contact
        </NavLink>
      </NavItem>
      <NavItem>
        <NavLink
          className={classnames({ active: activeTab === '3' })}
          onClick={() => { toggle('3'); }}
        >
          Address
        </NavLink>
      </NavItem>
    </Nav>
    <TabContent activeTab={activeTab}>
      <TabPane tabId="1">
        <Row>
          <Col sm="12">
            <table className="table mt-4">
				   <tbody>
				        <tr>
				          <th className="bg-light w-50">Active:</th><td>{brand.active ? 'Yes' : 'No'}</td>
				        </tr>
				        <tr>
				          <th className="bg-light">Name:</th><td>{brand.name?.en || brand.name}</td>
				        </tr>
				        <tr>
				          <th className="bg-light">Booking name:</th><td>{brand.booking_name}</td>
				        </tr>
				        <tr>
				          <th className="bg-light">Website:</th><td>{brand.website ? brand.website : '---' }</td>
				        </tr>
				        <tr>
				          <th className="bg-light">Description EN:</th><td>{brand.description?.en ? brand.description.en : '---' }</td>
				        </tr>
				        {/*
				        <tr>
				          <th className="bg-light">Online:</th><td>{brand.online ? 'Yes' : 'No'}</td>
				        </tr>
				        <tr>
				          <th className="bg-light">Offline:</th><td>{brand.offline ? 'Yes' : 'No'}</td>
				        </tr>
				        <tr>
				          <th className="bg-light">Featured:</th><td>{brand.featured ? 'Yes' : 'No'}</td>
				        </tr>
				    	*/}
				        <tr>
				          <th className="bg-light">Instagram:</th><td>{brand.instagram ? brand.instagram : '---'}</td>
				        </tr>
				        <tr>
				          <th className="bg-light">Facebook:</th><td>{brand.facebook ? brand.facebook : '---'}</td>
				        </tr>
				        <tr>
				          <th className="bg-light">Twitter:</th><td>{brand.twitter ? brand.twitter : '---'}</td>
				        </tr>
				        <tr>
				          <th className="bg-light">Snapchat:</th><td>{brand.snapchat ? brand.snapchat : '---'}</td>
				        </tr>
			        </tbody>
			      </table>
          </Col>
        </Row>
      </TabPane>
      <TabPane tabId="2">
      	<Row>
          <Col sm="12">
          	{ brand.contact!=null &&
              <table className="table mt-4">
  							<tbody>
  							 <tr>
  				          <th className="bg-light w-50">Position:</th><td>{brand.contact.position}</td>
  				        </tr>
  				        <tr>
  				          <th className="bg-light">Salutation:</th><td>{brand.contact.salutation}</td>
  				        </tr>
  				        <tr>
  				          <th className="bg-light">First name:</th><td>{brand.contact.first_name}</td>
  				        </tr>
  				        <tr>
  				          <th className="bg-light">Last name:</th><td>{brand.contact.last_name}</td>
  				        </tr>
  				        <tr>
  				          <th className="bg-light">Email:</th><td>{brand.contact.email}</td>
  				        </tr>
  				        <tr>
  				          <th className="bg-light">Phone:</th><td>{brand.contact.phone}</td>
  				        </tr>
  				        <tr>
  				          <th className="bg-light">Fax:</th><td>{brand.contact.fax}</td>
  				        </tr>
  				        </tbody>
  				    </table>
            }
          </Col>
        </Row>
      </TabPane>
      <TabPane tabId="3">
				<Row>
          <Col sm="12">
            { brand.address!=null &&
              <table className="table mt-4">
  							<tbody>
  				        <tr>
  				          <th className="bg-light w-50">Title:</th><td>{brand.address.title}</td>
  				        </tr>
  				        <tr>
  				          <th className="bg-light">Country:</th><td>{brand.address.country}</td>
  				        </tr>
  				        <tr>
  				          <th className="bg-light">City:</th><td>{brand.address.city}</td>
  				        </tr>
  				        <tr>
  				          <th className="bg-light">Street:</th><td>{brand.address.street}</td>
  				        </tr>
  				        <tr>
  				          <th className="bg-light">ZIP:</th><td>{brand.address.zip}</td>
  				        </tr>
  				        </tbody>
  				    </table>
            }
          </Col>
        </Row>
      </TabPane>
    </TabContent>
		</div>
	)

}
